<template>
  <v-dialog v-model="mostrarModal" scrollable max-width="750px">
    <v-card>
      <v-card-title>{{ tituloFormulario }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" class="pb-0">
                <h3 class="mb-2">Datos generales</h3>
              </v-col>

              <v-col cols="12" class="py-0">
                <div class="mb-1">
                  <v-icon x-small>info_outline</v-icon>
                  <span class="ml-1 caption">Nombre de la plataforma</span>
                </div>

                <v-text-field
                  label="Nombre *"
                  outlined
                  dense
                  autocomplete="off"
                  v-model="formulario.nombrePlataforma"
                  :rules="[validacion.required]"
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <h3 class="mb-2">Automatización de mensajería</h3>
              </v-col>

              <v-col cols="12" class="pt-0">
                <div class="mb-1">
                  <v-icon x-small>info_outline</v-icon>
                  <span small class="ml-1 caption">
                    Dirección para el envío de correos
                  </span>
                </div>

                <v-text-field
                  label="Url *"
                  outlined
                  dense
                  hide-details="auto"
                  autocomplete="off"
                  v-model="formulario.url"
                  :rules="[
                    validacion.required,
                    validacion.urlCaracter,
                    validacion.urlValida,
                  ]"
                />
              </v-col>

              <v-col cols="12" class="pb-1">
                <h3 class="mb-2">Logo</h3>
              </v-col>

              <v-col cols="12" sm="6">
                <imagen-compania
                  :nombre-logo="formulario.nameLogo"
                  @change="cargarLogo($event)"
                  @mostrar-error="$emit('mostrar-error', $event)"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-color-picker
                  mode="hexa"
                  v-model="formulario.color"
                  hide-mode-switch
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="cerrarModal()">Cancelar</v-btn>
        <v-btn color="green" text @click="guardar()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getRules } from '../../../../utils/validationsUtil';
import ImagenCompania from '../../../../components/ImagenCompania.vue';

export default {
  name: 'CrearEditarCompania',

  components: {
    ImagenCompania,
  },

  data() {
    return {
      mostrarModal: false,
      datosIniciales: null,
      formulario: {
        nombrePlataforma: '',
        url: '',
        color: '',
        nameLogo: '',
        logoBinario: null,
      },
      validacion: {
        required: getRules('required')[0],
        urlCaracter: getRules('urlCaracter')[0],
        urlValida: getRules('urlValida')[0],
      },
    };
  },

  computed: {
    esEdicion() {
      return this.datosIniciales !== null;
    },
    tituloFormulario() {
      return this.esEdicion
        ? 'Editar parámetros generales'
        : 'Registrar parámetros generales';
    },
  },

  methods: {
    reglas(...nombresDeReglas) {
      return getRules(...nombresDeReglas);
    },

    guardar() {
      if (this.$refs.form.validate()) {
        this.$emit('guardar', {
          datosFormulario: { ...this.formulario },
          datosIniciales: this.datosIniciales,
        });
      }
    },

    cargarLogo(archivoBinario) {
      this.formulario.logoBinario = archivoBinario;
    },

    abrirModal(item = null) {
      this.datosIniciales = item;

      Object.assign(this.formulario, this.$options.data().formulario);

      if (item) {
        this.formulario.nombrePlataforma = item.nombrePlataforma || '';
        this.formulario.url = item.url || '';
        this.formulario.color = item.color || '';
        this.formulario.nameLogo = item.urlLogo || '';
      }

      this.mostrarModal = true;
    },

    cerrarModal() {
      this.mostrarModal = false;
      this.datosIniciales = null;
      Object.assign(this.formulario, this.$options.data().formulario);
    },
  },
};
</script>
